import {
  RewardHistory
} from 'helpers/models';

export const mapRewardHistory = (result) => {
  return new RewardHistory(result).mapToStandard();
};